<template>
  <vx-card class="mb-base alarm-filters">
    <div class="vx-row items-end">
      <div class="vx-col w-full sm:w-full md:w-1/3 lg:w-1/3 mb-4">
        <label class="vs-input--label"
          >{{ $t("sidebar.Apiaries") }}:
          <feather-icon
            class="ml-2 bx-spin"
            :class="apiaryDisabled == true ? '' : 'd-none'"
            icon="LoaderIcon"
            svgClasses="w-4 h-4"
          ></feather-icon
        ></label>
        <v-select
          :options="apiaryOptions"
          v-model="apiaryValue"
          @input="apiaryHandleChange"
          :clearable="true"
          :placeholder="$t('sidebar.Apiaries')"
          @search="handleApiarySearch"
          :disabled="apiaryDisabled"
        >
          <template v-slot:no-options="{ searching }">
            <template v-if="searching">
              {{ $t("select.NoMatching") }}
            </template>
            <template v-else>
              {{ $t("select.NoData") }}
            </template>
          </template>
          <template #list-footer>
            <li
              ref="load-rule-apiary"
              class="loader"
              v-if="isApiaryLazyLoadLoading == true"
            >
              <div class="flex items-center justify-center w-full">
                <div>
                  <feather-icon
                    icon="LoaderIcon"
                    class="mr-3 bx-spin text-warning"
                    svgClasses="w-5 h-5"
                  ></feather-icon>
                </div>
              </div>
              <infinite-loading @infinite="apiaryInfiniteHandler">
                <div slot="spinner"></div>
                <div slot="no-more"></div>
                <div slot="no-results"></div>
              </infinite-loading>
            </li>
          </template>
        </v-select>
      </div>
      <div class="vx-col w-full sm:w-full md:w-1/3 lg:w-1/3 mb-4">
        <label class="vs-input--label"
          >{{ $t("sidebar.Hives") }}:<feather-icon
            class="ml-2 bx-spin"
            :class="hiveDisabled == true ? '' : 'd-none'"
            icon="LoaderIcon"
            svgClasses="w-4 h-4"
          ></feather-icon
        ></label>
        <v-select
          :options="hiveOptions"
          v-model="hiveValue"
          @input="hiveHandleChange"
          :clearable="true"
          :placeholder="$t('sidebar.Hives')"
          @search="handleHiveSearch"
          :disabled="hiveDisabled"
        >
          <template v-slot:no-options="{ searching }">
            <template v-if="searching">
              {{ $t("select.NoMatching") }}
            </template>
            <template v-else>
              {{ $t("select.NoData") }}
            </template>
          </template>
          <template #list-footer>
            <li
              ref="load-rule-apiary"
              class="loader"
              v-if="isHiveLazyLoadLoading == true"
            >
              <div class="flex items-center justify-center w-full">
                <div>
                  <feather-icon
                    icon="LoaderIcon"
                    class="mr-3 bx-spin text-warning"
                    svgClasses="w-5 h-5"
                  ></feather-icon>
                </div>
              </div>
              <infinite-loading @infinite="hiveInfiniteHandler">
                <div slot="spinner"></div>
                <div slot="no-more"></div>
                <div slot="no-results"></div>
              </infinite-loading>
            </li>
          </template>
        </v-select>
      </div>
      <div class="vx-col w-full sm:w-full md:w-1/3 lg:w-1/3 mb-4">
        <label class="vs-input--label">{{ $t("search.Text") }}:</label>
        <div
          class="
            vs-component vs-con-input-label vs-input
            w-full
            vs-input-warning
          "
        >
          <div class="vs-con-input">
            <input
              name="search"
              icon-no-border
              icon="icon icon-search"
              icon-pack="feather"
              v-model="search"
              class="
                w-full
                search-btn
                vs-inputx
                vs-input--input
                normal
                icon-after-input
              "
              @input="handleSearch(search)"
              :placeholder="$t('search.Text')"
              autocomplete="off"
              icon-after
            />
            <span
              class="
                vs-icon
                notranslate
                icon-scale icon-inputx
                notranslate
                vs-input--icon
                material-icons
                null
                icon-after
                px-2
                pt-1
              "
            >
              <feather-icon
                @click="clearSearchFilter"
                icon="XIcon"
                svgClasses="w-4 h-4"
                class="cursor-pointer"
              />
            </span>
          </div>
        </div>
      </div>
    </div>
  </vx-card>
</template>
<script>
import i18n from '../../../i18n/i18n.js'
import vSelect from 'vue-select'
import InfiniteLoading from 'vue-infinite-loading'

export default {
  components: {
    vSelect,
    InfiniteLoading
  },
  data () {
    return {
      // Apiary
      apiaryDisabled: true,
      apiaryOptions: [],
      apiaryValue: { label: i18n.t('apiaries.allApiaries'), value: '*' },
      apiaryFirstData: { label: i18n.t('apiaries.allApiaries'), value: '*' },
      apiaryCursor: null,
      isApiaryLazyLoadLoading: false,

      //Hive
      hiveDisabled: true,
      hiveOptions: [],
      hiveValue: { label: i18n.t('hives.allHives'), value: '*' },
      hiveFirstData: { label: i18n.t('hives.allHives'), value: '*' },
      hiveCursor: null,
      isHiveLazyLoadLoading: false,

      //Search
      search: '',

      filters:{
        apiary:null,
        hive:null,
        search:null
      }
    }
  },
  watch:{
    '$route.query': {
      handler (n, o) {
        if (o) {
          if (
            n && Object.prototype.hasOwnProperty.call(n, 'apiary') && Object.prototype.hasOwnProperty.call(n, 'hive')
          ) {
            if (this.userRole !== 'user') {
              this.getApiary(n.apiary)
              this.getHives(`?user=${this.userInfo.user_id}&apiary=${n.apiary}`)
              this.getHive(n.hive)
            } else {
              this.getHives(`?apiary=${n.apiary}`)
              this.getHive(n.hive)
            }
          }
        }
      },
      deep: true,
      immediate: true
    }
  },
  computed: {
    userInfo () {
      return this.$store.getters.returnUserInfo
    },
    userRole () {
      return this.$store.getters.userRole
    },
    alarmFilters () {
      return this.$store.getters.alarmFilters
    }
  },
  mounted () {
    const query = this.$route.query

    this.$store.dispatch('getAlarmFilters', {data:null, type:'apiary'})
    this.$store.dispatch('getAlarmFilters', {data:null, type:'hive'})
    this.$store.dispatch('getAlarmFilters', {data:null, type:'search'})


    if (
      query && Object.prototype.hasOwnProperty.call(query, 'apiary') && Object.prototype.hasOwnProperty.call(query, 'hive')
    ) {
      if (this.userRole !== 'user') {
        this.getApiaries(`?user=${this.userInfo.user_id}`)
        this.getApiary(query.apiary)
        this.getHives(`?user=${this.userInfo.user_id}&apiary=${query.apiary}`)
        this.getHive(query.hive)
      } else {
        this.getApiaries('')
        this.getApiary(query.apiary)
        this.getHives(`?apiary=${query.apiary}`)
        this.getHive(query.hive)
      }
    } else if (this.userRole !== 'user') {
      this.getApiaries(`?user=${this.userInfo.user_id}`)
      this.getHives(`?user=${this.userInfo.user_id}`)
    } else {
      this.getApiaries('')
      this.getHives('')
    }
  },
  methods: {
    // Apiary Operations
    getApiary (apiaryId) {
      this.$store
        .dispatch('getApiary', { id: apiaryId })
        .then((response) => {
          this.apiaryValue = {
            value: response.data.id,
            label: response.data.name
          }
          this.$store.dispatch('getAlarmFilters', {data:Number(apiaryId), type:'apiary'})
        })
        .catch(() => {})
    },
    apiaryHandleChange (val) {
      let filter = null
      this.hiveDisabled = true
      this.hiveValue = this.hiveFirstData
      if (val && Object.prototype.hasOwnProperty.call(val, 'value')) {
        if (val.value !== '*') {
          filter = val.value
          if (this.userRole !== 'user') {
            this.getHives(
              `?user=${this.userInfo.user_id}&apiary=${val.value}`
            )
          } else {
            this.getHives(`?apiary=${val.value}`)
          }
        } else {
          filter = null
          if (this.userRole !== 'user') {
            this.getHives(`?user=${this.userInfo.user_id}`)
          } else {
            this.getHives('')
          }
        }
      } else {
        filter = null
        this.apiaryValue = this.apiaryFirstData
        if (this.userRole !== 'user') {
          this.getHives(`?user=${this.userInfo.user_id}`)
        } else {
          this.getHives('')
        }
      }
      this.$store.dispatch('getAlarmFilters', {data:filter, type:'apiary'})
      this.$store.dispatch('getAlarmFilters', {data:null, type:'hive'})
    },
    handleApiarySearch (search) {
      let searchData = `?search=${search}`
      if (this.userRole !== 'user') {
        searchData = `?user=${this.userInfo.user_id}&search=${search}`
      }
      this.getApiaries(searchData)
    },
    getApiaries (params) {
      this.$store
        .dispatch('getApiariesData', params)
        .then((response) => {
          this.apiaryOptions = [this.apiaryFirstData]

          if (response.data.results.length) {
            response.data.results.map((value) => {
              this.apiaryOptions.push({
                label: value.name,
                value: value.id
              })
            })
          }

          this.apiaryDisabled = false

          this.apiaryCursor = response.data.next
          if (response.data.next === null) {
            this.isApiaryLazyLoadLoading = false
          } else {
            this.isApiaryLazyLoadLoading = true
          }
        })
        .catch((error) => {
          this.apiaryDisabled = false
          this.errorMsg(error)
        })
    },
    apiaryInfiniteHandler ($state) {
      if (this.apiaryCursor !== null) {
        this.$store
          .dispatch('getApiariesLazyLoadData', this.apiaryCursor)
          .then((response) => {
            const lazyLoadData = []
            if (response.data.results.length) {
              response.data.results.map((value, index) => {
                lazyLoadData.push({
                  label: value.name,
                  value: value.id
                })
                if (index + 1 === response.data.results.length) {
                  this.apiaryOptions.push(...lazyLoadData)
                }
              })
            }
            this.apiaryCursor = response.data.next
            if (response.data.next === null) {
              this.isApiaryLazyLoadLoading = false
              $state.complete()
            } else {
              this.isApiaryLazyLoadLoading = true
              $state.loaded()
            }
          })
          .catch((error) => {
            this.errorMsg(error)
          })
      }
    },

    // Apiary Operations
    getHive (hiveId) {
      this.$store
        .dispatch('getHive', { id: hiveId })
        .then((response) => {
          this.hiveValue = {
            value: response.data.id,
            label: response.data.name
          }
          this.$store.dispatch('getAlarmFilters', {data:Number(hiveId), type:'hive'})
        })
        .catch(() => {})
    },
    hiveHandleChange (val) {
      let filter = null
      if (val && Object.prototype.hasOwnProperty.call(val, 'value')) {
        if (val.value !== '*') {
          filter = val.value
        } else {
          filter = null
        }
      } else {
        filter = null
        this.hiveValue = this.hiveFirstData
      }
      this.$store.dispatch('getAlarmFilters', {data:filter, type:'hive'})
    },
    handleHiveSearch (search) {
      let searchData = `?search=${search}`
      if (this.userRole !== 'user') {
        searchData = `?user=${this.userInfo.user_id}&search=${search}`
      }
      this.getHives(searchData)
    },
    getHives (params) {
      this.$store
        .dispatch('getHivesData', params)
        .then((response) => {
          this.hiveOptions = [this.hiveFirstData]
          response.data.results.map((value) => {
            this.hiveOptions.push({
              label: value.name,
              value: value.id
            })
          })
          this.hiveDisabled = false

          this.hiveCursor = response.data.next
          if (response.data.next === null) {
            this.isHiveLazyLoadLoading = false
          } else {
            this.isHiveLazyLoadLoading = true
          }
        })
        .catch((error) => {
          this.apiaryDisabled = false
          this.errorMsg(error)
        })
    },
    hiveInfiniteHandler ($state) {
      if (this.hiveCursor !== null) {
        this.$store
          .dispatch('getHivesLazyLoadData', this.hiveCursor)
          .then((response) => {
            const lazyLoadData = []
            if (response.data.results.length) {
              response.data.results.map((value, index) => {
                lazyLoadData.push({
                  label: value.name,
                  value: value.id
                })
                if (index + 1 === response.data.results.length) {
                  this.hiveOptions.push(...lazyLoadData)
                }
              })
            }
            this.hiveCursor = response.data.next
            if (response.data.next === null) {
              this.isHiveLazyLoadLoading = false
              $state.complete()
            } else {
              this.isHiveLazyLoadLoading = true
              $state.loaded()
            }
          })
          .catch((error) => {
            this.errorMsg(error)
          })
      }
    },

    // Search Operations
    handleSearch  (search) {
      if (search.length) {
        this.filters.search = search
      } else {
        this.filters.search = null
      }
      this.$store.dispatch('getAlarmFilters', {data:this.filters.search, type:'search'})
    },
    clearSearchFilter () {
      this.search = ''
      this.$store.dispatch('getAlarmFilters', {data:null, type:'search'})
    },
    errorMsg (error) {
      this.$store.dispatch('errorMsg', error).then((res) => {
        this.$vs.notify({
          title: i18n.t('notifyAlert.error.title'),
          text: res,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger',
          position: 'top-right'
        })
      })
    }
  }

}
</script>
<style lang="scss">
.alarm-filters {
  .multiselect-btn {
    .multiselect__tags {
      border-radius: 5px 0px 0px 5px !important;
      height: 40px !important;
    }

    .multiselect__single {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis !important;
    }
  }
  .d-none {
    display: none !important;
  }

  .search-btn {
    height: 40px !important;
    border: 1px solid rgba(0, 0, 0, 0.2);
  }

  .vx-card__body {
    padding-bottom: 0px !important;
    padding-top: 1rem !important;
  }
}
</style>